import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetDocumentListTktEffect } from './get-document-list-tkt.effect';
import { getDocumentListTktReducer } from './get-document-list-tkt.reducer';
import { GET_DOCUMENT_LIST_TKT_STORE_NAME, GetDocumentListTktState } from './get-document-list-tkt.state';

/** Token of the GetDocumentListTkt reducer */
export const GET_DOCUMENT_LIST_TKT_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetDocumentListTktState, Action>>(
  'Feature GetDocumentListTkt Reducer'
);

/** Provide default reducer for GetDocumentListTkt store */
export function getDefaultGetDocumentListTktReducer() {
  return getDocumentListTktReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_DOCUMENT_LIST_TKT_STORE_NAME, GET_DOCUMENT_LIST_TKT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetDocumentListTktEffect]),
  ],
  providers: [{ provide: GET_DOCUMENT_LIST_TKT_REDUCER_TOKEN, useFactory: getDefaultGetDocumentListTktReducer }],
})
export class GetDocumentListTktStoreModule {
  public static forRoot<T extends GetDocumentListTktState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetDocumentListTktStoreModule> {
    return {
      ngModule: GetDocumentListTktStoreModule,
      providers: [{ provide: GET_DOCUMENT_LIST_TKT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
